<template>

  <div class="lotti-weekly-container">

    <div class="lotti-grid-row lotti-grid-row-mid">

      <div class="lotti-grid-col lotti-grid-col-50">

        <div class="lotti-weekly-table-module">

          <div class="lotti-module-title">Wochenlektionen Übersicht</div>

          <div class="lotti-module-nav">

            <el-button
                icon="el-icon-plus"
                type="success"
                @click="openCreateLessonsDialog"
                circle>
            </el-button>

          </div>

          <el-table :data="tableData"
                    class="lotti-module-table"
                    ref="weeklyLessonsTable"
                    height="490px"
                    stripe
                    :row-key="tableData.id"
                    :default-sort="sortingParams"
                    @sort-change="setSortingParams"
                    @hook:mounted="tableMounted"
                    @hook:beforeDestroy="tableBeforeDestroy"
                    style="width: 100%">

            <!--dynamic with column1 -->
            <el-table-column
                prop="kw"
                label="Jahr / KW"
                min-width="60px"
                sortable="custom"
                :sort-orders="allowedSorting">
            </el-table-column>

            <!--dynamic with column2 -->
            <el-table-column
                prop="minutes"
                label="Minuten"
                min-width="100px"
                sortable="custom"
                :sort-orders="allowedSorting">
            </el-table-column>

            <el-table-column
                label=""
                :sortable="false"
                width="130px">
              <template slot-scope="scope">
                <el-button
                    icon="el-icon-edit"
                    size="mini"
                    @click="openEditLessonsDialog(scope.row)">
                </el-button>
                <el-button
                    icon="el-icon-delete"
                    size="mini"
                    type="danger"
                    @click="openDeleteLessonsDialog(scope.row)">
                </el-button>
              </template>
            </el-table-column>

          </el-table>

        </div>

      </div>

      <div class="lotti-grid-col lotti-grid-col-50 lotti-grid-mini">

        <div class="lotti-weekly-overview-module">

          <div class="lotti-module-title">Wochenlektionen Überzeit</div>
          <div class="lotti-weekly-stats">{{ overtime > 0 ? '+' : '' }}{{ overtime }} min</div>

          <div class="lotti-module-title">Anzahl Kalenderwochen</div>
          <div class="lotti-weekly-stats">{{ overtimeWeekCount }}</div>

        </div>

      </div>

      <div class="lotti-grid-col lotti-grid-col-50 lotti-grid-mini">

        <weekly-report :lead-view="auth.user.profile.permissions.is_leader"></weekly-report>

      </div>

    </div>

    <el-dialog :visible.sync="dialogFormVisible" title="Erstelle Wochenlektionen" width="350px">

      <el-form  label-width="110px" prop="weekly-lessons-dialog-form" class="lotti-weekly-lessons-form">

        <el-form-item label="Minuten">
          <el-input-number
              v-model="weeklyLessonForm.minutes"
              size="medium"
              controls-position="right"
              :min="1"
              :max="2147483647"> <-- Maximum positive integer in pgSql --!>
          </el-input-number>
        </el-form-item>

        <el-form-item label="Kalenderwoche">
          <el-date-picker
              v-model="weeklyLessonForm.date"
              type="week"
              size="medium"
              format="yyyy / WW"
              :disabled="!!weeklyLessonForm.id"
              :clearable="false"
              :change="onWeekPickerChange()"
              :picker-options="{firstDayOfWeek: 1}"
              placeholder="Woche wählen">
          </el-date-picker>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Abbrechen</el-button>
        <el-button type="primary" @click="createLessons">Speichern</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="deleteDialogVisible" title="Delete" width="300px">

      Wochenlektionen wirklich löschen?

      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">Abbrechen</el-button>
        <el-button type="primary" @click="deleteLessons(deleteRow)">Löschen</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>

import auth from "../../auth";
import Vue from "../../main";
import notification from "../../Helpers/NotificationHelper";
import DatePickerHelper from "../../Helpers/DatePickerHelper";
import WeeklyReport from "../modules/WeeklyReport";

export default {

  data() {

    return {
      auth: auth,
      datePickerHelper: DatePickerHelper,

      sortingParams: {
        prop: 'kw',
        order: 'descending'
      },

      //table information
      pageNumber: 0,
      tableData: [],
      thereIsMoreData: true,
      allowedSorting: ['ascending', 'descending'],
      tableSelector: '.lotti-weekly-container .el-table__body-wrapper',
      tableElement: null,

      //dialog
      dialogFormVisible: false,
      deleteDialogVisible: false,

      //stored rows for delete
      deleteRow: null,
      editRow: null,

      //input form data
      weeklyLessonForm: {
        id: null,
        minutes: 1,
        date: Date.now(),
        weekNumber: null,
        year: null,
      },

      //overtime
      overtime: 0,
      overtimeWeekCount: 0,
    }
  },

  methods: {

    setSortingParams(column, prop, order) {
      this.sortingParams.prop = column.prop;
      this.sortingParams.order = column.order;
    },

    getAllMyWeeklyLessons() {

      //increase page number BEFORE submitting!
      this.pageNumber += 1;

      Vue.http.get(
        'api/v1/weekly-lessons/get-all-my',
        {
          params: {
            column: this.sortingParams.prop,
            order: this.sortingParams.order === 'ascending' ? 'asc' : 'desc',
            page: this.pageNumber,
          }
        }
      ).then(response => {

        //concat the data at the end of the already loaded data if != null
        if (response.data) {
          this.tableData = this.tableData.concat(response.data);
        } else {
          //block further requests, there is no more data
          this.thereIsMoreData = false;
        }
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    getOvertimeForWeeklyLessons() {

      Vue.http.get(
          'api/v1/weekly-lessons/overtime'
      ).then(response => {
        this.overtime = response.data.therapy.WorkedMinutes - response.data.therapy.QuotaMinutes;
        this.overtimeWeekCount = response.data.weekCount;
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    onWeekPickerChange() {

      //calc new weekNumber and year
      let d = new Date(this.weeklyLessonForm.date)
      let {weekNumber, year} = DatePickerHelper.getWeekNumberAndYear(d)
      year = parseInt(year.toString().substr(-2), 10) //get only decade number e.g. 24

      //compare new values with old, if there is a change, update them + get new overtime data
      if (this.weeklyLessonForm.weekNumber !== weekNumber || this.weeklyLessonForm.year !== year) {

        this.weeklyLessonForm.weekNumber = weekNumber;
        this.weeklyLessonForm.year = year;
      }
    },

    openCreateLessonsDialog() {

      this.weeklyLessonForm.id = null;
      this.weeklyLessonForm.minutes = 1;
      this.weeklyLessonForm.date = Date.now();

      this.dialogFormVisible = true
    },

    createLessons() {

      //close dialog
      this.dialogFormVisible = false

      //check if isUpdate
      let isUpdate = !!this.weeklyLessonForm.id

      Vue.http.post(

          //update or create? decide based on id field
          isUpdate ? 'api/v1/weekly-lessons/update' : 'api/v1/weekly-lessons/create',
          {
            id: this.weeklyLessonForm.id,
            week: this.weeklyLessonForm.weekNumber,
            year: this.weeklyLessonForm.year,
            minutes: this.weeklyLessonForm.minutes,
          }
      ).then(response => {

        if (isUpdate) {

          //only update the row, no reload
          this.editRow.minutes = this.weeklyLessonForm.minutes

        } else {

          //reset table and reload
          this.resetTableLoader();//reset values on each form filter change
          this.getAllMyWeeklyLessons();
        }

        //trigger new overtime calculations
        this.getOvertimeForWeeklyLessons()

        //show success msg
        notification.showSuccess(this, 'Daten wurden erfolgreich gespeichert');

      }, error => {
        notification.showError(this, 'Daten konnten nicht gespeichert werden');
      })
    },

    openEditLessonsDialog(row) {

      this.editRow = row

      this.weeklyLessonForm.id = row.id;
      this.weeklyLessonForm.minutes = row.minutes;

      //split 21 / 53 into kw and year
      let v = row.kw.toString().split('/')
      this.weeklyLessonForm.weekNumber = parseInt(v[1].trim(),10);
      this.weeklyLessonForm.year = parseInt(v[0].trim(),10);

      //calc date based on WK and year
      this.weeklyLessonForm.date = DatePickerHelper.getDateOfISOWeekAndYear(this.weeklyLessonForm.weekNumber, this.weeklyLessonForm.year);

      //open modal
      this.dialogFormVisible = true;
    },

    openDeleteLessonsDialog(row) {
      this.deleteDialogVisible = true;
      this.deleteRow = row;
    },

    deleteLessons(row) {

      //close dialog
      this.deleteDialogVisible = false

      Vue.http.post(

          //delete lessons
          'api/v1/weekly-lessons/delete',
          {
            id: row.id
          }
      ).then(response => {

        //show success msg
        notification.showSuccess(this, 'Daten wurden erfolgreich gelöscht');

        //remove row from table data
        let index = this.tableData.indexOf(row);
        if (index > -1) {
          this.tableData.splice(index, 1);
        }

        //trigger new overtime calculations
        this.getOvertimeForWeeklyLessons()

      }, error => {
        notification.showError(this, 'Daten konnten nicht gelöscht werden');
      })
    },

    handleOnInfiniteScroll(event) {
      //implement infinite scroll
      if (
          this.thereIsMoreData &&
          Math.ceil(this.tableElement.clientHeight + this.tableElement.scrollTop) >= this.tableElement.scrollHeight
      ) {
        // you're at the bottom of the page
        this.getAllMyWeeklyLessons();
      }
    },

    resetTableLoader() {
      this.pageNumber = 0;//reset page size on filter change
      this.tableData = [];//reset tableData as well

      //allow loading for further data after reset
      this.thereIsMoreData = true;
    },

    tableMounted() {
      //select table element first
      this.tableElement = document.querySelector(this.tableSelector);
      //add event listener secondly
      this.tableElement.addEventListener('scroll', this.handleOnInfiniteScroll);
    },

    tableBeforeDestroy() {
      this.tableElement.removeEventListener('scroll', this.handleOnInfiniteScroll);
    }
  },

  watch: {
    sortingParams: {
      handler(newValue, oldValue) {
        this.resetTableLoader();//reset values on each form filter change
        this.getAllMyWeeklyLessons();
      },
      deep: true,
    }
  },

  beforeMount() {

    //get all therapists in selected service
    this.getAllMyWeeklyLessons();

    //get overtime for weekly lessons
    this.getOvertimeForWeeklyLessons()
  },

  components: {
    WeeklyReport
  },
}

</script>